
export enum Images {
   CREDIT="https://storageaccountourimbea2.blob.core.windows.net/web/credit.svg",
   PACKIT="https://storageaccountourimbea2.blob.core.windows.net/web/packit.svg",
   DROPIT="https://storageaccountourimbea2.blob.core.windows.net/web/dropitoff.svg",
   TRADEIT="https://storageaccountourimbea2.blob.core.windows.net/web/tradeit.svg",
   SHIPPINGCODE="https://storageaccountourimbea2.blob.core.windows.net/web/shippingcode.svg",
   SHIPPINGLABEL="https://storageaccountourimbea2.blob.core.windows.net/web/shippinglabel.svg",
   QRCODE="https://storageaccountourimbea2.blob.core.windows.net/web/qrcode.svg",
   PICKUP="https://storageaccountourimbea2.blob.core.windows.net/web/shipping.svg",
   BURDLOGO="https://storageaccountourimbea2.blob.core.windows.net/web/burd_logo.png",
   POSTNORDLOGO="https://storageaccountourimbea2.blob.core.windows.net/web/postnord_logo.png",
   NOT_FOUND="https://storageaccountourimbea2.blob.core.windows.net/web/not-found.png",
   TRADEIN_RETAILER="https://storageaccountourimbea2.blob.core.windows.net/web/forhandler.png",
   TRADEIN_DTC="https://storageaccountourimbea2.blob.core.windows.net/web/online.png",
   PLACEHOLDER="https://storageaccountourimbea2.blob.core.windows.net/web/not-found.png",
}
